import React, { useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../lib/api';
import { AuthContext } from '../../contexts/AuthContext';
import { SiteContext } from '../../contexts/SiteContext';

function deleteCookie(name) {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${encodeURIComponent(name)}=; Max-Age=0; Path=/; SameSite=Lax${secure}`;
}

export default function AdminHeader() {
  const { t, i18n } = useTranslation();
  const { user, setUser } = useContext(AuthContext);
  const { website } = useContext(SiteContext);
  const { username, website: slug } = useParams();
  const navigate = useNavigate();

  const base = `/${username}/${slug}`;

  async function handleLogout() {
    try {
      await api.post('/auth/logout');
    } catch (e) {
      // ignore network hiccups — we'll still reset client state
      console.error(e);
    } finally {
      // Clear UI “remember me” cookies (optional)
      deleteCookie('vbw_remember');
      // If you also stored username: deleteCookie('vbw_username');

      // Reset auth state and go to login
      setUser({ auth: false, name: '', username: '', websites: [] });
      navigate('/', { replace: true });
    }
  }

  function toggleLang() {
    i18n.changeLanguage(i18n.language === 'en' ? 'se' : 'en');
  }

  return (
    <header className="bg-white px-4 py-3 shadow flex items-center gap-4">
      <div className="flex items-center gap-3">
        <div className="text-cyan-600 font-extrabold text-lg tracking-wide">VBWEBB</div>
        <div className="text-gray-500 text-sm hidden sm:block">CMS 1.1.2</div>
      </div>

      <h1 className="font-bold text-xl truncate">
        {website?.title || t('general.welcome')}
      </h1>

      <nav className="ml-auto flex items-center gap-2 sm:gap-3">
        <Link to={`${base}/edit`} className="underline">{t('header.edit')}</Link>
        <Link to={`${base}/settings`} className="underline">{t('header.settings')}</Link>

        <span className="mx-2 hidden sm:inline text-gray-300">|</span>

        <button
          onClick={toggleLang}
          className="px-2 py-1 rounded hover:bg-gray-100 text-sm"
          type="button"
          aria-label="Toggle language"
        >
          EN/SE
        </button>

        <button
          onClick={handleLogout}
          className="px-3 py-1.5 rounded bg-gray-900 text-white text-sm hover:bg-gray-800"
          type="button"
        >
          {t('auth.logOut')}
        </button>
      </nav>
    </header>
  );
}
